/**
 * @file
 * A JavaScript file containing the how-to functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.boxImage = {
    attach: function (context) {
      $(".box-image__subtitle", context).each(function () {
        var $this = $(this).children("div");
        $this.text($this.text().trim());
        var lines = $(this).children("div")[0]?.getClientRects().length;
        while (lines > 5) {
          $this.text($this.text().split(" ").slice(0, -1).join(" ") + "…");
          lines = $(this).children("div")[0]?.getClientRects().length;
        }
      });
      $(".box-image__title", context).each(function () {
        var $this = $(this).children("div");
        $this.text($this.text().trim());
        var lines = $(this).children("div")[0]?.getClientRects().length;
        while (lines > 3) {
          $this.text($this.text().split(" ").slice(0, -1).join(" ") + "…");
          lines = $(this).children("div")[0]?.getClientRects().length;
        }
      });
    },
  };
})(Drupal, jQuery);
